<template>
<popup
  @close="$emit('close')"
  :special-background-color="alertColor"
>
  <div slot="popupMainContent" class="p-3 text-center">
    <icon
        type="exclamation-triangle"
        class="mb-2"
        size="3"
    /><br />
   <div class="mb-1">{{ alertMessage }}</div>
    <div
        :key="button.text"
        @click="button.action"
        class="settings-button d-inline-block mr-1"
        v-for="button in alertButtons">
      {{ $t(button.text) }}
    </div>
    <slot />
  </div>
</popup>
</template>

<script>
import Popup from "@/components/Popup.vue";
import Icon from "@/components/Icon.vue";
import {vformAlertSchemas} from "@/enum";
export default {
  name: "vFormAlert",
  components: {Popup, Icon},
  props: {
    alertSchema: {type: String, required: true},
    alertArguments: {type: Object, default: () => ({})},
    alertButtons: {type: Array, default: () => ([])},
  },
  data() {
    return {
      vformAlertSchemas
    };
  },
  computed: {
    alertObject() {
      const alertObject = this.vformAlertSchemas[this.alertSchema];
      return alertObject ? alertObject : {};
    },
    alertMessage() {
      const translationString = this.alertObject.translationString || '';
      return this.$t('vform.' + translationString, this.alertArguments);
    },
    alertColor() {
      return this.alertObject.color || '';
    }
  },
  beforeMount() {
    if (!this.vformAlertSchemas[this.alertSchema]) {
      console.error(`vFormAlert: Unknown alert schema "${this.alertSchema}"`);
    }
  }
}
</script>


<style scoped lang="scss">

</style>